export const defaultApolloOptions = {
  notifyOnNetworkStatusChange: true
};
